import { saveAs } from 'file-saver';
/* Image source placeholder - we need that to avoid borders and failed image icon */
export const INVISIBLE_IMAGE_SRC =
  "data:image/svg+xml;charset=utf8,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%3E%3C/svg%3E";

export const downloadImage = (imageUrl, fileName) => {
  saveAs(imageUrl, fileName);
};
